/**
 * The BlueSphere logo.
 *
 * Two variants, same artwork: the wordmark is white on the dark canvas
 * and brand navy on light surfaces. The sphere mark keeps its own colors
 * in both — gradients plus #76B7CD, #98C1D9 and the coral #EE6C4D, which
 * appears nowhere else in the product.
 *
 * The light variant is generated from the portal's `dark-logo.svg` by
 * swapping the 34 wordmark fills, rather than using the portal's own
 * `light-logo.svg`: that file is an 800KB Illustrator export with a
 * raster image embedded in it, against 29KB of clean vector here. A CSS
 * invert filter was the other option and would have destroyed the mark's
 * colors.
 */

export interface LogoProps {
  /** `light` for the dark canvas (default), `dark` for light surfaces. */
  variant?: 'light' | 'dark';
  className?: string;
}

export function Logo({ variant = 'light', className }: LogoProps) {
  return (
    <img
      src={`/assets/bluesphere-logo-${variant}.svg`}
      alt="BlueSphere"
      // Intrinsic size hints prevent the header reflowing as it loads.
      width={230}
      height={48}
      className={className ?? 'h-9 w-auto md:h-10'}
    />
  );
}
